import { useState } from 'react';

const useFileUpload = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const upload = async (file) => {
    let res;
    try {
      setLoading(true);
      const fd = new FormData();
      fd.append('files', file);
      res = await fetch(`${process.env.GATSBY_API_URL}/api/upload`, {
        method: 'post',
        body: fd,
      });
    } catch (err) {
      setError(err);
      if (typeof Sentry === 'undefined') {
        console.warn('There is no Sentry, not sending...');
        return;
      }
      Sentry.captureException(err, (scope) => {
        scope.clear();
        scope.setContext('file', file);
        return scope;
      });
      return;
    }

    let json;
    try {
      json = await res.json();
    } catch (err) {
      setError(err);
      if (typeof Sentry === 'undefined') {
        console.warn('There is no Sentry, not sending...');
        return;
      }
      Sentry.captureException(err, (scope) => {
        scope.clear();
        scope.setContext('file', file);
        return scope;
      });
      return;
    }

    setResult(json[0]);
    setLoading(false);
  };

  return {
    upload,
    result,
    loading,
    error,
  };
};

export default useFileUpload;
